<template>
  <TopPanel>
    <BreadCrumbs :items="items" class="s-bread" />
    <div class="button-container">
      <!-- <div
        v-tooltip.bottom="{
          value: !isCreateButtonEnabled
            ? 'Для сохранения сегмента необходимо ввести название сегмента, период и указать условия выборки (категория и(или) бренд и(или) магазин), пол, а также обновить счетчик аудитории.'
            : '',
          class: 'white-tooltip',
          disabled: isCreateButtonEnabled,
        }"
      > -->
      <Button
        label="Сохранить сегмент"
        class="segment-save-button m-l-16 m-r-16"
        :disabled="!isCreateButtonEnabled"
        @click="createSegment"
        :loading="isLoading"
      />
      <!-- </div> -->
    </div>
  </TopPanel>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";

import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";
import Button from "primevue/button";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";

const props = defineProps<{
  isCreateButtonEnabled: boolean;
  isLoading: boolean;
  isSegmentSetted?: boolean;
}>();

const emit = defineEmits(["createSegment"]);

const items = computed(() => [
  { label: "Сегмент", route: "listSegments" },
  { label: props.isSegmentSetted ? "Просмотр сегмента" : "Создание сегмента" },
]);

const createSegment = () => {
  emit("createSegment");
};
</script>

<style lang="scss" scoped>
.s-bread {
  margin-left: 18px;
}

.button-container {
  flex: 1;

  display: flex;
  justify-content: end;

  margin: 0 20px;
}

.segment-save-button {
  width: 240px;
}
</style>
